/* eslint-disable no-case-declarations */
import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  ineligibleProviderData: [],
  deletedData: [],
  errorMessagesInRedux: [],
  editedData: [],
  gridData: [],
  ineligiblePrvUpdateRes: [],
  addedProviderData: [],
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_INELIGIBLLE_PROVIDER_DATA:
      return {
        ...state,
        ineligibleProviderData: action.ineligibleProviderData,
      };
    case actionTypes.VIEW_HISTORY:
      return { ...state, planViewHistory: action.planViewHistory };
    case actionTypes.HANDLE_ERROR_MESSAGE_MIP:
      return { ...state, errorMessagesInRedux: action.payload };
    case actionTypes.SET_GRID_DATA:
      const data = action.payload;
      const newAddRecord = data?.filter((element) => element.newRecord);
      const oddRecord = data?.filter((element) => !element.newRecord);
      return {
        ...state,
        gridData: [...newAddRecord, ...oddRecord]?.map((item) => {
          item.ineligProviderBeginDtErr =
            item.ineligProviderBeginDtErr || false;
          item.endDtErr = item.endDtErr || false;
          item.addEditRow = item.addEditRow || false;
          item.isUpdateIneligProviderBeginDt =
            item.isUpdateIneligProviderBeginDt || false;
          item.isUpdateEndDt = item.isUpdateEndDt || false;

          return item;
        }),
      };
    case actionTypes.SET_EDITED_DATA:
      return { ...state, editedData: action.payload };
    case actionTypes.RESET_INELIGIBLE_PROVIDERS_STORE:
      return { ...axiosPayLoad };
    case actionTypes.CLEAR_TAB_STATE_INELIGIBLE_PROVIDER:
      return { ...state,
        deletedData: [],
        errorMessagesInRedux: [],
        editedData: [],
        ineligiblePrvUpdateRes: [],
        addedProviderData: [],
       };
    case actionTypes.INELIGIBLE_PROV_RES:
      return { ...state, ineligiblePrvUpdateRes: action.payload };
    case actionTypes.SET_DELETED_DATA:
      return { ...state, deletedData: action.payload };
    case actionTypes.SET_NEW_PROVIDER_DATA:
      return { ...state, addedProviderData: action.payload };
    case actionTypes.CLEAR_REDUX_DATA_INELIGIBLE_PROVIDER:
      return { ...axiosPayLoad };
    default:
      return state;
  }
};

export default reducer;
